<template>
<!-- report -->
<div class="text-body-2 ma-0">
  <span v-if="report.institution" v-html="report.institution"></span>,&nbsp;
  <span v-if="year==2100">, to appear</span>
  <span v-if="year < 2100">{{year}}</span>
  </div>
</template>
<script>
export default {
  props:['report','year'],
}
</script>

